import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadCcRequirementPriorityById,
    setCcRequirementPriorityEdit,
    setCcRequirementPriorityReloadEdit,
    initCcRequirementPriority,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface PriorityEditProps {
    priorityId: number
    editAccess: boolean
}

const Edit = ({
    priorityId,
    editAccess,
}: PriorityEditProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const priority = useSelector((state: StoreType) => state.ccRequirementPriority.priorityEdit)
    const reloadEdit = useSelector((state: StoreType) => state.ccRequirementPriority.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcRequirementPriorityReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcRequirementPriorityReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (priorityId === 0) {
            dispatch(setCcRequirementPriorityEdit(initCcRequirementPriority))
            reload()
        } else {
            setLoadState(PENDING)
            LoadCcRequirementPriorityById(priorityId, userData.accountId, project.id).then((res) => {
                dispatch(setCcRequirementPriorityEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!priority) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {
                        priority.id
                            ? (editAccess ? `${lang.editPriority} #${priority.id}` : `${lang.viewPriority} #${priority.id}`)
                            : lang.addPriority
                    }
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form priority={priority} editAccess={editAccess} />
                }
                {
                    reloadEdit
                    && <Form priority={priority} editAccess={editAccess} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
